import React, { useContext } from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import AnnotationTable from "../annotation-table";
import { StoresContext } from "../../pages/_app";

export const ProtistanAnnotations = observer(() => {
  const rootStore = useContext(StoresContext);
  const classes = classNames("genomes-annotations", {
    "genomes-annotations--comparison": rootStore.annotationStore.isComparison,
  });

  return (
    <div className={classes}>
      <AnnotationTable collectionName="protistology" />
    </div>
  );
});
